<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 ziro-report-content">
    @if (isReadOnly !== null) {
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item>
          <div
            [innerHTML]="
              (isReadOnly
                ? 'tkey;pages.admin.orphaned_devices.description.read_only'
                : 'tkey;pages.admin.orphaned_devices.description'
              ) | escapeHtml
            "
          ></div>
        </ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>
    }

    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    @if (!isLoading && orphanedDevices.length === 0) {
      <div data-automation="orphaned-devices-no-results" class="alert alert-info">
        <span [innerHTML]="'tkey;pages.admin.orphaned_devices.subtitle' | escapeHtml: { total: '0' }"></span>
      </div>
    }

    @if (!isLoading && orphanedDevices.length > 0) {
      <ziro-datatable
        [isCondensed]="true"
        [columns]="columns"
        [rowDataSource]="orphanedDevices"
        [uniqueRowIdentifier]="'pkid'"
        [showSelectColumn]="!isReadOnly"
        [mainFilterPlaceholder]="
          ('tkey;reports.datatable.search_placeholder' | translate) +
          ('tkey;pages.admin.orphaned_devices.deviceName' | translate) +
          '...'
        "
        (rowSelected)="setDeleteButtonState()"
        [dataAutomation]="tableDataAutomation"
        [class]="'ziro-card'"
      >
        <ziro-datatable-multi-select-filter
          [label]="'tkey;pages.admin.orphaned_devices.deviceType'"
          [items]="deviceTypeFilterOptions"
          [matchFn]="isDeviceTypeMatch"
          [dataAutomation]="'orphaned-devices-device-type-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;pages.admin.orphaned_devices.clusterName'"
          [items]="cucmClusterFilterOptions"
          [matchFn]="isCucmClusterMatch"
          [dataAutomation]="'orphaned-devices-cucm-cluster-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
      </ziro-datatable>
    }
  </div>
</div>

@if (!isReadOnly) {
  <ziro-bottom-nav></ziro-bottom-nav>
}
